import React, { useMemo, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getCtInspctionType,
  deleteCtInspctionType,
  updateCtInspctionType,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { Button, Input } from 'antd'
import styled from 'styled-components'
import { getEnvConfig, getPermitActions } from '../core/selectors'
const TableTD = styled.td`
  text-align: end;
`

const headers = [
  strCol({
    ident: 'inspectionId',
    display: 'inspection Id',
    isKey: true,
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'inspectionType',
    display: 'Inspection Type',
    isKey: true,
    width: 500,
    sortOrder: 'asc',
  }),
]

const title = 'CT Inspection Type'

const CtInspectionType = ({ envConfig, actionPermits }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Inspection Id :</TableTD>
            <td colSpan={1}>
              <Input
                style={{ width: '100%' }}
                value={insertData.inspectionId}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    inspectionId: e.target.value,
                  })
                }}
              />
            </td>
            <TableTD>Inspection Type :</TableTD>
            <td colSpan={1}>
              <Input
                style={{ width: '100%' }}
                value={insertData.inspectionType}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    inspectionType: e.target.value,
                  })
                }}
              />
            </td>

            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const hasWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CT_INSPECTION_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <CommonScreen
      // heightOffset={280}
      widthOffset={50}
      insertCompHeight={50}
      // totalWidth={500}
      isAdminScreen={false}
      withoutModify={!hasWritePermission}
      allowInsert={hasWritePermission}
      title={title}
      header={headers}
      saveTask={updateCtInspctionType}
      retrieveTask={getCtInspctionType}
      deleteTask={deleteCtInspctionType}
      altBy={d => d.inspectionId}
      autoRetrieve
      sortOptions={headers}
      insertComp={insertEvent && hasWritePermission && insertComp}
      onInsertEvent={b => setInsertEvent(hasWritePermission && b)}
      headerRowHeight={30}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(CtInspectionType)
